export const RitualSeal = ({ className = "", spin = true }) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    className={`${className} ${spin ? "seal-spin" : ""}`}
    aria-hidden="true"
  >
    <circle cx="200" cy="200" r="196" stroke="currentColor" strokeWidth="0.6" opacity="0.5" />
    <circle cx="200" cy="200" r="170" stroke="currentColor" strokeWidth="0.5" opacity="0.4" />
    <circle cx="200" cy="200" r="120" stroke="currentColor" strokeWidth="0.7" opacity="0.55" />
    <circle cx="200" cy="200" r="60" stroke="currentColor" strokeWidth="0.8" opacity="0.7" />
    {Array.from({ length: 36 }).map((_, i) => {
      const a = (i * 10 * Math.PI) / 180;
      const long = i % 3 === 0;
      const r1 = long ? 178 : 186;
      return (
        <line
          key={i}
          x1={200 + r1 * Math.cos(a)}
          y1={200 + r1 * Math.sin(a)}
          x2={200 + 194 * Math.cos(a)}
          y2={200 + 194 * Math.sin(a)}
          stroke="currentColor"
          strokeWidth="0.7"
          opacity="0.5"
        />
      );
    })}
    <path d="M200 80 L304 260 L96 260 Z" stroke="currentColor" strokeWidth="0.6" opacity="0.45" />
    <path d="M200 320 L96 140 L304 140 Z" stroke="currentColor" strokeWidth="0.6" opacity="0.45" />
    <circle cx="200" cy="200" r="10" stroke="currentColor" strokeWidth="0.8" opacity="0.8" />
    <circle cx="200" cy="200" r="2.5" fill="currentColor" opacity="0.9" />
  </svg>
);
